import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useFetch } from '../../hooks';
import RatingList from './RatingList';
import RatingBox from '../../components/ui/RatingBox';
import QRCode from 'react-qr-code';
import { LuPrinter } from "react-icons/lu";
import QrPrintableService from '../rating-services/QrPrintableService';
import { MwButton } from '../../components/ui';
import { useTranslation } from 'react-i18next';
import { printableDiv } from '../../utils/global';

const RatingManager = () => {
    const [t] = useTranslation('global')
    const params = useParams();
    const [serviceRatingSum,setServiceRatingSum] = useState(0);
    const [employeeRatingSum,setEmployeeRatingSum] = useState(0);
    const printableRef = useRef(null);
    const {data:serviceWithRatingsResult,loading:ratingsLoading,refreshHandler:refreshRatings} = useFetch(`${process.env.REACT_APP_RATING_API_BASE_URL}/services/rating/${params.serviceId}`);
    const ratings = serviceWithRatingsResult?.data?.ratings || [];
    const ratingResult = {
        ...serviceWithRatingsResult,
        data: ratings
    };

    const _qrValue = `${process.env.REACT_APP_RATING_WEB_USER_BASE_URL}/${params.tenant}/${params.serviceId}` ;

    const Print = () => {
        if (!printableRef.current) return;
        printableDiv(printableRef);
    }

    useEffect(()=>{
        if(serviceWithRatingsResult){
            const currentRatings = serviceWithRatingsResult?.data?.ratings || [];
            const _serviceRatingSum = currentRatings.reduce((a,b)=> a + (b.ratingService || 0) ,0);
            const _rateService = _serviceRatingSum > 0 ? Math.round((_serviceRatingSum / (currentRatings.length * 5) ) * 5 ) : 0;
            setServiceRatingSum(_rateService);

            const _employeeRatingSum = currentRatings.reduce((a,b)=> a + (b.ratingEmployee || b.ratingService || 0) ,0);
            const _rateEmployee = _employeeRatingSum > 0 ? Math.round((_employeeRatingSum / (currentRatings.length * 5) ) * 5 ) : 0;
            setEmployeeRatingSum(_rateEmployee);
        }
    },[serviceWithRatingsResult]);


    return (
        <div>
            <div className='flex gap-2 justify-between'>
                <div className='flex-1 flex flex-col justify-between '>
                    <div>
                        { serviceWithRatingsResult && 
                        <div className='w-full  flex justify-between text-slate-700 font-bold p-3'>
                            <div>{serviceWithRatingsResult?.data?.serviceName}</div>
                            <MwButton type='secondary' actionType='button' onClick={Print}>
                                <div className='flex gap-1 hover:text-slate-900 '><LuPrinter className='hover:text-slate-900' size={16}/> {t('common.print')} </div>
                            </MwButton>
                        </div> }
                        <hr className='mb-3 mx-3'/>
                    </div>
                    {
                        serviceWithRatingsResult?.data?.serviceDesc &&
                            <div className=' h-24 overflow-auto mb-3'>
                                <div className='text-xs text-slate-400 flex '>{serviceWithRatingsResult?.data?.serviceDesc}</div>
                            </div>
                    }
                    <div>
                        <hr className='mb-3 mx-3'/>
                        <div className='flex justify-between  gap-1 text-xs'>
                            <div className='flex flex-col items-center gap-1 px-3 '>
                                <span>{t('reports.totalServiceRating')}</span>
                                <RatingBox rate={serviceRatingSum} size={26}/>
                            </div>
                            <div className='flex flex-col items-center gap-1 px-3 '>
                                <span>{t('reports.totalEmployeeRating')}</span>
                                <RatingBox rate={employeeRatingSum} size={26}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-60'>
                    <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={_qrValue}
                        viewBox={`0 0 256`}
                        />
                </div>
            </div>
            <hr className='my-3'/>
            <RatingList data={ratingResult} loading={ratingsLoading} onDeleteSuccess={refreshRatings} />
            {serviceWithRatingsResult && <QrPrintableService item={serviceWithRatingsResult?.data} printableRef={printableRef} /> }
        </div>
    )
}

export default RatingManager
